import {
  useAssignAccountTransactionMutation,
  useGetPossibleAccountTransactionsQuery,
} from "@apis/accountTransactions/useAccountTransactions"
import { DataTable } from "@components/DataTable/DataTable"
import { tableColumnsAccountTransactions } from "./tableColumnSchema"
import { ButtonCell } from "@utils/table/columnFactories"
import type { ColumnDef } from "@tanstack/react-table"
import type { IAccountTransaction } from "@apis/accountTransactions/types"
import { toast } from "sonner"
import type { AxiosError } from "axios"

type TPossibleAccountTransactionsProps = {
  account_id: string
}

export default function PossibleAccountTransactions({
  account_id,
}: TPossibleAccountTransactionsProps) {
  const getPossibleAccountTransactionsQuery =
    useGetPossibleAccountTransactionsQuery(account_id)
  const assignAccountTransactionMutation = useAssignAccountTransactionMutation()

  const columnSchema: ColumnDef<IAccountTransaction>[] = [
    ...tableColumnsAccountTransactions,
    {
      id: "assignToAccount",
      cell: (props) => (
        <ButtonCell
          {...props}
          variant="default"
          label="Assign to account"
          onClick={(rowData) => {
            assignAccountTransactionMutation.mutate(
              {
                account_transaction_id: rowData.account_transaction_id,
                data: { account_id: account_id },
              },
              {
                onSuccess: () => {
                  toast.success("Transaction assigned to account!")
                },
                onError: (error: string | AxiosError) =>
                  toast.error(`Error assigning transaction to account! ${error}`),
              },
            )
          }}
        />
      ),
    },
  ]

  return (
    <div>
      <h3>Possible Account Transactions</h3>
      {getPossibleAccountTransactionsQuery.isError ? (
        <div className="tw:text-red-500">
          {`There was an error loading Pending Account Transactions. Error: ${getPossibleAccountTransactionsQuery.error?.message}`}
        </div>
      ) : (
        <DataTable
          columns={columnSchema}
          data={getPossibleAccountTransactionsQuery.data ?? []}
          pending={getPossibleAccountTransactionsQuery.isPending}
          condensed={true}
        />
      )}
    </div>
  )
}
